<div class="root">
    <div class="image-container">
        @if (uploading) {
            <div class="uploading-spinner">
                <div class="loading-root" (mousewheel)="$event.preventDefault()">
                    <div>
                        <mat-progress-spinner
                            mode="determinate"
                            color="accent"
                            [value]="uploadProgress$ | async"
                        ></mat-progress-spinner>
                        <h1>{{ uploadProgress$ | async }}%</h1>
                    </div>
                </div>
            </div>
        }
        <img #image [src]="asset.thumbnail" />
    </div>

    @if (user.id === asset.author.id) {
        <input #file type="file" (change)="sendFile()" />
        @if (asset["image"] !== undefined && !asset.custom_thumbnail) {
            <button mat-stroked-button (click)="crop()">
                <mat-icon>crop</mat-icon>
                <span> Crop</span>
            </button>
        }
        @if (asset.custom_thumbnail) {
            <button mat-button (click)="resetThumbnail()">
                <mat-icon fontSet="material-icons-outlined">hide_image</mat-icon>
                <span> Reset Thumbnail</span>
            </button>
        } @else {
            <button mat-button (click)="browseFiles()" matTooltip="Upload a new thumbnail">
                <mat-icon>upload</mat-icon>
                <span> Upload</span>
            </button>
        }
        <ng-template #upload>
            <button mat-button (click)="browseFiles()" matTooltip="Upload a new thumbnail">
                <mat-icon>upload</mat-icon>
                <span> Upload</span>
            </button>
        </ng-template>
    }
</div>
